/**
 * @generated SignedSource<<13497cbb438679c5b19cc01d05476258>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNav_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyMobileNavRefineMenuFilters_viewer">;
  readonly " $fragmentType": "BuyMobileNav_viewer";
};
export type BuyMobileNav_viewer$key = {
  readonly " $data"?: BuyMobileNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyMobileNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobileNav_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyMobileNavRefineMenuFilters_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9e293ca5c08edabde5932d099c01015a";

export default node;
